export default __webpack_public_path__ + "static/clock-f65161d1665540df186a38d36abfe666.mp4";